import FooterVideo from './footer-video';
export default FooterVideo;